export default __webpack_public_path__ + "static/media/animals.7c8849f0.png";